import http from "@/axios";
import {SaleDetails} from "@/store/sale/types";

export default class SaleStore {

    public static fetchSaleDetails(saleId: string): Promise<SaleDetails> {
        return http.get('/api/sale/' + saleId + '/details')
            .then(r => r.data)
            .then(obj => {
                return Object.assign(new SaleDetails(), obj);
            });
    }
}
